import React, { SVGAttributes } from 'react';
import { Svg, Path } from '@react-pdf/renderer';

interface Props extends SVGAttributes<SVGSVGElement> {
  color?: string;
}

export default function OcWorkBalance({ ...rest }: Props) {
  return (
    <svg
      width="215"
      height="82"
      viewBox="0 0 215 82"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M76.9002 113.737C80.4214 102.924 86.2091 84.5956 87.8566 76.8733C87.8635 76.841 87.8828 76.8148 87.9109 76.7974C95.0896 72.3322 102.855 69.9032 105.466 69.4184C105.498 69.4125 105.529 69.4206 105.556 69.439C112.208 74.0892 116.323 76.9314 118.867 79.351C125.336 85.5043 126.567 97.3034 126.454 104.983C126.454 105.027 126.43 105.066 126.392 105.087L123.725 106.56C123.659 106.596 123.578 106.565 123.551 106.496C121.374 100.644 117.314 96.0266 114.658 87.6347C114.66 87.7027 114.602 87.7625 114.53 87.7607C107.312 87.5763 107.022 87.1605 100.509 85.1703C96.6222 97.5676 85.5227 109.801 80.0167 115.063C79.9819 115.096 79.9327 115.104 79.8883 115.085L76.9702 113.885C76.9114 113.861 76.8805 113.798 76.9002 113.737Z"
        fill="#211249"
      />
      <path
        d="M96.5254 42.1078C97.1332 41.1961 103.742 38.766 101.292 30.1737C103.426 29.2223 103.781 26.9525 101.819 26.9534C99.6827 26.8572 99.0605 25.163 98.9304 24.0559C98.8466 22.5641 98.2668 21.2241 98.0321 20.9961"
        stroke="#211249"
        strokeWidth="0.607787"
        strokeLinecap="round"
      />
      <path
        d="M98.1765 28.0374C98.4582 27.9118 98.5338 27.4676 98.3454 27.0451C98.1571 26.6226 97.7761 26.382 97.4945 26.5075C97.2128 26.6331 97.1372 27.0773 97.3255 27.4998C97.5139 27.9223 97.8949 28.163 98.1765 28.0374Z"
        fill="#211249"
      />
      <path
        d="M95.6866 26.0344C95.8667 25.4928 96.5278 24.5178 97.7317 24.9496"
        stroke="#211249"
        strokeWidth="0.607787"
        strokeLinecap="round"
      />
      <path
        d="M96.6715 34.512C97.783 35.2142 98.6285 35.17 99.7193 33.8853"
        stroke="#211249"
        strokeWidth="0.607787"
        strokeLinecap="round"
      />
      <path
        d="M88.1138 29.9438C88.1152 30.3444 88.3348 31.1543 89.2002 31.1897"
        stroke="#211249"
        strokeWidth="0.607787"
        strokeLinecap="round"
      />
      <path
        d="M79.0785 29.9794C80.3309 34.8778 84.4794 37.0907 87.5553 38.8439C89.059 36.8427 91.156 32.7639 89.7707 33.065C88.3147 33.3813 85.262 30.4169 86.0384 28.7235C86.9494 26.7366 89.2075 28.0702 90.1491 29.4359L90.3973 26.7802C89.3795 25.4706 88.0611 22.9586 90.931 23.3869C93.8007 23.8151 96.8629 21.9487 98.0353 20.9621C99.8106 17.8504 101.89 11.5406 96.0059 11.194C91.1119 10.9058 87.2163 15.9077 85.1896 19.7244C82.8192 20.1386 77.3709 23.3007 79.0785 29.9794Z"
        fill="#211249"
      />
      <path
        d="M87.563 38.4727C89.0473 39.1834 89.9612 39.9202 90.8121 41.9259"
        stroke="#211249"
        strokeWidth="0.607787"
        strokeLinecap="round"
      />
      <path
        d="M89.0219 56.3414C89.4818 59.5816 89.7681 68.2005 87.2957 77.0283C87.2645 77.1399 87.3909 77.2319 87.4859 77.1654C90.1314 75.3125 97.0432 71.4294 105.936 69.1317C105.995 69.1164 106.035 69.0624 106.028 69.0018C105.449 64.1098 105.138 53.8262 107.962 51.1364C107.977 51.1216 107.995 51.1122 108.016 51.1074C113.839 49.7632 126.194 45.4809 129.797 38.7913C129.802 38.7814 129.805 38.7712 129.808 38.7601C130.067 37.5507 130.244 35.081 128.933 34.6558C128.907 34.6474 128.879 34.6489 128.854 34.6591C120.254 38.1368 110.668 41.0173 98.3488 43.2021"
        stroke="#211249"
        strokeWidth="0.607787"
        strokeLinecap="round"
      />
      <path
        d="M89.0221 60.4749C83.1387 66.8932 77.664 69.3374 73.4906 71.1608C70.5749 72.6472 64.2522 73.7135 67.081 69.1055C79.2368 53.9351 81.911 51.2973 84.7676 48.6839C86.4083 47.1829 87.138 46.2527 91.2709 45.1587"
        stroke="#211249"
        strokeWidth="0.607787"
        strokeLinecap="round"
      />
      <path
        d="M138.131 19.1445H133.025C132.522 19.1445 132.114 19.5527 132.114 20.0562V23.8245C132.114 24.328 132.522 24.7362 133.025 24.7362H138.131C138.634 24.7362 139.043 24.328 139.043 23.8245V20.0562C139.043 19.5527 138.634 19.1445 138.131 19.1445Z"
        stroke="#211249"
        strokeWidth="0.607787"
      />
      <path
        d="M146.761 17.686H143.358C142.854 17.686 142.446 18.0942 142.446 18.5977V23.46C142.446 23.9635 142.854 24.3717 143.358 24.3717H146.761C147.265 24.3717 147.673 23.9635 147.673 23.46V18.5977C147.673 18.0942 147.265 17.686 146.761 17.686Z"
        stroke="#211249"
        strokeWidth="0.607787"
      />
      <path
        d="M155.392 14.6484H152.11C151.606 14.6484 151.198 15.0566 151.198 15.5601V23.4614C151.198 23.9649 151.606 24.373 152.11 24.373H155.392C155.895 24.373 156.303 23.9649 156.303 23.4614V15.5601C156.303 15.0566 155.895 14.6484 155.392 14.6484Z"
        stroke="#211249"
        strokeWidth="0.607787"
      />
      <path
        d="M164.266 11.5479H160.862C160.191 11.5479 159.647 12.0921 159.647 12.7634V23.4605C159.647 24.1318 160.191 24.6761 160.862 24.6761H164.266C164.937 24.6761 165.481 24.1318 165.481 23.4605V12.7634C165.481 12.0921 164.937 11.5479 164.266 11.5479Z"
        fill="#211249"
      />
      <path
        d="M173.261 17.2002H169.979C169.475 17.2002 169.067 17.6084 169.067 18.1119V23.4604C169.067 23.9639 169.475 24.3721 169.979 24.3721H173.261C173.765 24.3721 174.173 23.9639 174.173 23.4604V18.1119C174.173 17.6084 173.765 17.2002 173.261 17.2002Z"
        stroke="#211249"
        strokeWidth="0.607787"
      />
      <path
        d="M182.377 20.2397H178.974C178.47 20.2397 178.062 20.6479 178.062 21.1514V23.461C178.062 23.9645 178.47 24.3727 178.974 24.3727H182.377C182.881 24.3727 183.289 23.9645 183.289 23.461V21.1514C183.289 20.6479 182.881 20.2397 182.377 20.2397Z"
        stroke="#211249"
        strokeWidth="0.607787"
      />
      <path
        d="M168.52 0H156.729C156.058 0 155.514 0.544231 155.514 1.21557V7.77968C155.514 8.45102 156.058 8.99525 156.729 8.99525H168.52C169.192 8.99525 169.736 8.45102 169.736 7.77968V1.21557C169.736 0.544231 169.192 0 168.52 0Z"
        fill="#211249"
      />
      <path
        d="M162.625 9.87749C162.528 9.98935 162.356 9.98935 162.258 9.87749L161.211 8.66846C161.074 8.51101 161.186 8.26611 161.394 8.26611H163.49C163.698 8.26611 163.809 8.51101 163.673 8.66846L162.625 9.87749Z"
        fill="#211249"
      />
      <path
        d="M167.67 4.1333H159.89C159.621 4.1333 159.404 4.35099 159.404 4.61953C159.404 4.88807 159.621 5.10576 159.89 5.10576H167.67C167.938 5.10576 168.156 4.88807 168.156 4.61953C168.156 4.35099 167.938 4.1333 167.67 4.1333Z"
        fill="white"
      />
      <path
        d="M157.945 4.61956C157.945 4.41815 157.782 4.25488 157.58 4.25488C157.379 4.25488 157.216 4.41815 157.216 4.61956C157.216 4.82096 157.379 4.98423 157.58 4.98423C157.782 4.98423 157.945 4.82096 157.945 4.61956Z"
        stroke="white"
        strokeWidth="0.243115"
      />
      <path
        d="M163.05 6.44287H159.89C159.621 6.44287 159.404 6.66056 159.404 6.9291C159.404 7.19764 159.621 7.41533 159.89 7.41533H163.05C163.319 7.41533 163.537 7.19764 163.537 6.9291C163.537 6.66056 163.319 6.44287 163.05 6.44287Z"
        fill="white"
      />
      <path
        d="M160.741 1.70215H157.58C157.312 1.70215 157.094 1.91984 157.094 2.18838C157.094 2.45692 157.312 2.67461 157.58 2.67461H160.741C161.009 2.67461 161.227 2.45692 161.227 2.18838C161.227 1.91984 161.009 1.70215 160.741 1.70215Z"
        fill="white"
      />
      <path
        d="M158.066 6.9291C158.066 6.66056 157.849 6.44287 157.58 6.44287C157.312 6.44287 157.094 6.66056 157.094 6.9291C157.094 7.19764 157.312 7.41533 157.58 7.41533C157.849 7.41533 158.066 7.19764 158.066 6.9291Z"
        fill="white"
      />
      <path
        d="M139.932 34.5347C140.071 34.8574 140.122 35.5706 139.326 36.0031C139.268 36.0352 139.203 36.0657 139.135 36.0944C138.139 36.5102 137.891 35.8265 137.891 35.4326V35.0314"
        stroke="#211249"
        strokeWidth="0.607787"
        strokeLinecap="round"
      />
      <path
        d="M139.803 33.5425C140.071 33.7038 140.437 34.1133 139.932 34.535C139.895 34.5665 139.852 34.598 139.803 34.6296C139.221 35.0131 138.393 35.0634 137.891 35.0317C137.799 35.0258 137.719 35.0173 137.652 35.0076C137.381 34.9319 136.944 34.6377 137.365 34.067"
        stroke="#211249"
        strokeWidth="0.607787"
        strokeLinecap="round"
      />
      <path
        d="M139.613 32.3608C139.884 32.4238 140.349 32.6728 140.043 33.1643C139.737 33.6558 138.194 33.9677 137.461 34.0623C137.43 34.0654 137.398 34.067 137.365 34.0669C137.076 34.0658 136.791 33.9255 136.791 33.5424C136.791 33.0011 137.493 32.8177 137.652 32.7862"
        stroke="#211249"
        strokeWidth="0.607787"
        strokeLinecap="round"
      />
      <path
        d="M138.009 30.7542C138.28 30.8645 138.445 31.2645 137.795 31.6048C137.145 31.945 137.302 32.4083 137.461 32.5973C137.716 32.8178 138.541 32.9848 139.803 31.8884C141.066 30.7919 139.086 30.1081 137.891 29.9033"
        stroke="#211249"
        strokeWidth="0.607787"
        strokeLinecap="round"
      />
      <path
        d="M135.213 31.8888C135.756 31.4635 136.811 30.868 136.696 31.8888C136.581 32.9097 135.852 33.354 135.5 33.4486"
        stroke="#211249"
        strokeWidth="0.607787"
        strokeLinecap="round"
      />
      <path
        d="M135.213 35.9814C135.531 35.7085 136.072 34.8158 135.69 33.4287"
        stroke="#211249"
        strokeWidth="0.607787"
        strokeLinecap="round"
      />
      <path
        d="M135.446 31.5569L134.849 28.3232"
        stroke="#211249"
        strokeWidth="0.607787"
        strokeLinecap="round"
      />
      <path
        d="M137.584 27.7754L137.991 31.0809"
        stroke="#211249"
        strokeWidth="0.607787"
        strokeLinecap="round"
      />
      <path
        d="M138.52 36.2129C138.52 37.1156 138.952 38.3034 137.991 38.5884C136.818 38.9364 136.694 37.8757 136.454 36.783L135.829 33.5049"
        stroke="#211249"
        strokeWidth="0.607787"
        strokeLinecap="round"
      />
      <path
        d="M135.092 30.3291C134.423 30.4507 132.855 31.1314 131.931 32.8818C131.007 34.6322 130.129 35.1914 129.804 35.2522"
        stroke="#211249"
        strokeWidth="0.607787"
        strokeLinecap="round"
      />
      <path
        d="M129.986 38.29C131.688 38.4724 135.201 38.3995 136.368 37.1353"
        stroke="#211249"
        strokeWidth="0.607787"
        strokeLinecap="round"
      />
      <path
        d="M135.153 28.2618C138.375 28.2618 140.987 25.6495 140.987 22.427C140.987 19.2046 138.375 16.5923 135.153 16.5923C131.93 16.5923 129.318 19.2046 129.318 22.427C129.318 25.6495 131.93 28.2618 135.153 28.2618Z"
        stroke="#211249"
        strokeWidth="0.607787"
      />
      <path
        d="M214.107 62.2719C211.776 62.7502 212.869 65.9606 211.161 66.8147C209.121 67.8345 208.418 62.0933 208.683 59.6565C208.76 58.588 210.004 58.1128 210.171 59.6565C210.35 61.2963 208.315 67.6548 205.984 65.2012L204.428 63.3998C203.995 62.8668 203.143 62.1262 202.422 63.3998C201.701 64.6734 200.552 64.2526 200.069 63.8829L198.548 62.7764"
        stroke="#211249"
        strokeWidth="0.607787"
        strokeLinecap="round"
      />
      <path
        d="M199.638 57.8716L187.533 55.8212C187.414 55.8009 187.341 55.9499 187.432 56.0314L193.039 61.0808C193.048 61.0888 193.057 61.0955 193.069 61.0998C193.565 61.2949 195.469 60.5449 196.482 60.0913C196.551 60.0607 196.63 60.0981 196.65 60.1701C196.884 60.9877 197.166 61.7435 197.31 62.1038C197.332 62.1568 197.39 62.1861 197.429 62.1439C197.7 61.8449 197.738 60.3227 197.719 59.4491C197.717 59.3867 197.762 59.3339 197.824 59.3218C198.57 59.1763 199.577 58.5217 200.006 58.1979"
        stroke="#211249"
        strokeWidth="0.607787"
        strokeLinecap="round"
      />
      <path
        d="M196.603 60.0067C195.312 59.4124 192.045 57.924 189.309 56.7246"
        stroke="#211249"
        strokeWidth="0.607787"
        strokeLinecap="round"
      />
      <path
        d="M197.332 62.1945L194.901 60.7358"
        stroke="#211249"
        strokeWidth="0.607787"
        strokeLinecap="round"
      />
      <path
        d="M196.846 58.7913L193.564 57.8188"
        stroke="#211249"
        strokeWidth="0.607787"
        strokeLinecap="round"
      />
      <path
        d="M89.5967 45.6941C88.7256 44.6811 87.5059 42.5457 89.5967 42.1081C92.2102 41.5611 98.1057 41.6827 98.3488 43.1413"
        stroke="#211249"
        strokeWidth="0.607787"
        strokeLinecap="round"
      />
      <path
        d="M61.6006 77.6702C62.0733 77.9257 63.4986 78.0231 65.4177 76.3679C67.3369 74.7126 67.7566 73.237 67.7266 72.7061"
        stroke="#211249"
        strokeWidth="0.607787"
        strokeLinecap="round"
      />
      <path
        d="M59.2257 77.6298C59.1719 78.0866 59.4753 78.7871 61.1184 77.9343L61.6004 77.6701L62.4387 77.2104"
        stroke="#211249"
        strokeWidth="0.607787"
        strokeLinecap="round"
      />
      <path
        d="M58.7974 76.2153C58.4113 76.442 57.7893 77.0275 58.39 77.5561C58.5713 77.7156 58.8709 77.72 59.2251 77.6305C60.0448 77.4232 61.1566 76.7129 61.768 76.2567"
        stroke="#211249"
        strokeWidth="0.607787"
        strokeLinecap="round"
      />
      <path
        d="M65.9616 70.466C65.0556 70.1332 63.1839 69.484 61.94 69.9161C61.6278 70.0333 60.9203 70.1947 60.5873 69.903C60.1712 69.5384 59.3824 70.4737 60.4549 71.0995C61.5276 71.7252 62.2263 71.0618 62.0842 72.0552C61.9705 72.85 59.7696 74.1397 58.6834 74.6852C58.2932 74.8619 57.6485 75.3743 58.1919 76.0104C58.3265 76.1679 58.5403 76.2259 58.7986 76.2153C59.5839 76.183 60.7812 75.5173 61.4206 75.0861"
        stroke="#211249"
        strokeWidth="0.607787"
        strokeLinecap="round"
      />
      <path
        d="M34.1191 26.7243C37.3227 30.0034 43.2747 31.4483 46.412 31.8428C46.6337 31.8707 46.7117 32.1591 46.5318 32.2918L38.2773 38.3802C38.2505 38.4001 38.2195 38.4143 38.1869 38.4216C32.0752 39.7856 26.3772 33.7015 24.1163 30.2451C24.0301 30.1135 24.0943 29.9387 24.2435 29.8886L33.8646 26.6621C33.9543 26.632 34.0529 26.6566 34.1191 26.7243Z"
        stroke="#211249"
        strokeWidth="0.607787"
        strokeLinecap="round"
      />
      <path
        d="M29.3933 31.718C30.3658 31.516 32.4809 30.8871 33.1616 29.9868"
        stroke="#211249"
        strokeWidth="0.607787"
        strokeLinecap="round"
      />
      <path
        d="M32.1283 33.9062C32.7361 33.9263 34.134 33.6266 34.8633 32.2651"
        stroke="#211249"
        strokeWidth="0.607787"
        strokeLinecap="round"
      />
      <path
        d="M35.1057 35.3645C36.0174 35.2429 37.9745 34.55 38.5093 32.751"
        stroke="#211249"
        strokeWidth="0.607787"
        strokeLinecap="round"
      />
      <path
        d="M13.6164 52.1296C10.4127 55.4086 4.46075 56.8536 1.32348 57.248C1.10176 57.276 1.02372 57.5643 1.20363 57.6971L9.4581 63.7855C9.48497 63.8053 9.51596 63.8196 9.54854 63.8268C15.6603 65.1908 21.3583 59.1068 23.6192 55.6504C23.7054 55.5188 23.6412 55.344 23.492 55.2939L13.8709 52.0674C13.7812 52.0372 13.6826 52.0619 13.6164 52.1296Z"
        stroke="#211249"
        strokeWidth="0.607787"
        strokeLinecap="round"
      />
      <path
        d="M18.3429 57.1233C17.3704 56.9213 15.2553 56.2923 14.5746 55.3921"
        stroke="#211249"
        strokeWidth="0.607787"
        strokeLinecap="round"
      />
      <path
        d="M15.6077 59.3119C14.9999 59.3321 13.602 59.0323 12.8727 57.6709"
        stroke="#211249"
        strokeWidth="0.607787"
        strokeLinecap="round"
      />
      <path
        d="M12.6292 60.7712C11.7175 60.6496 9.76044 59.9568 9.22559 58.1577"
        stroke="#211249"
        strokeWidth="0.607787"
        strokeLinecap="round"
      />
      <path
        d="M53.5317 74.3807C49.8945 76.2213 43.0404 76.616 42.6197 65.0466C42.199 53.4772 32.4526 53.1264 27.6321 54.3975"
        stroke="#211249"
        strokeWidth="0.61594"
        strokeLinecap="round"
      />
    </svg>
  );
}

export const PdfOcWorkBalance = ({ width = 215, height = 82 }: Props) => (
  <Svg width={width} height={height} viewBox="0 0 215 82">
    <Path
      d="M76.9002 113.737C80.4214 102.924 86.2091 84.5956 87.8566 76.8733C87.8635 76.841 87.8828 76.8148 87.9109 76.7974C95.0896 72.3322 102.855 69.9032 105.466 69.4184C105.498 69.4125 105.529 69.4206 105.556 69.439C112.208 74.0892 116.323 76.9314 118.867 79.351C125.336 85.5043 126.567 97.3034 126.454 104.983C126.454 105.027 126.43 105.066 126.392 105.087L123.725 106.56C123.659 106.596 123.578 106.565 123.551 106.496C121.374 100.644 117.314 96.0266 114.658 87.6347C114.66 87.7027 114.602 87.7625 114.53 87.7607C107.312 87.5763 107.022 87.1605 100.509 85.1703C96.6222 97.5676 85.5227 109.801 80.0167 115.063C79.9819 115.096 79.9327 115.104 79.8883 115.085L76.9702 113.885C76.9114 113.861 76.8805 113.798 76.9002 113.737Z"
      fill="#211249"
    />
    <Path
      d="M96.5254 42.1078C97.1332 41.1961 103.742 38.766 101.292 30.1737C103.426 29.2223 103.781 26.9525 101.819 26.9534C99.6827 26.8572 99.0605 25.163 98.9304 24.0559C98.8466 22.5641 98.2668 21.2241 98.0321 20.9961"
      stroke="#211249"
      strokeWidth="0.607787"
    />
    <Path
      d="M98.1765 28.0374C98.4582 27.9118 98.5338 27.4676 98.3454 27.0451C98.1571 26.6226 97.7761 26.382 97.4945 26.5075C97.2128 26.6331 97.1372 27.0773 97.3255 27.4998C97.5139 27.9223 97.8949 28.163 98.1765 28.0374Z"
      fill="#211249"
    />
    <Path
      d="M95.6866 26.0344C95.8667 25.4928 96.5278 24.5178 97.7317 24.9496"
      stroke="#211249"
      strokeWidth="0.607787"
    />
    <Path
      d="M96.6715 34.512C97.783 35.2142 98.6285 35.17 99.7193 33.8853"
      stroke="#211249"
      strokeWidth="0.607787"
    />
    <Path
      d="M88.1138 29.9438C88.1152 30.3444 88.3348 31.1543 89.2002 31.1897"
      stroke="#211249"
      strokeWidth="0.607787"
    />
    <Path
      d="M79.0785 29.9794C80.3309 34.8778 84.4794 37.0907 87.5553 38.8439C89.059 36.8427 91.156 32.7639 89.7707 33.065C88.3147 33.3813 85.262 30.4169 86.0384 28.7235C86.9494 26.7366 89.2075 28.0702 90.1491 29.4359L90.3973 26.7802C89.3795 25.4706 88.0611 22.9586 90.931 23.3869C93.8007 23.8151 96.8629 21.9487 98.0353 20.9621C99.8106 17.8504 101.89 11.5406 96.0059 11.194C91.1119 10.9058 87.2163 15.9077 85.1896 19.7244C82.8192 20.1386 77.3709 23.3007 79.0785 29.9794Z"
      fill="#211249"
    />
    <Path
      d="M87.563 38.4727C89.0473 39.1834 89.9612 39.9202 90.8121 41.9259"
      stroke="#211249"
      strokeWidth="0.607787"
    />
    <Path
      d="M89.0219 56.3414C89.4818 59.5816 89.7681 68.2005 87.2957 77.0283C87.2645 77.1399 87.3909 77.2319 87.4859 77.1654C90.1314 75.3125 97.0432 71.4294 105.936 69.1317C105.995 69.1164 106.035 69.0624 106.028 69.0018C105.449 64.1098 105.138 53.8262 107.962 51.1364C107.977 51.1216 107.995 51.1122 108.016 51.1074C113.839 49.7632 126.194 45.4809 129.797 38.7913C129.802 38.7814 129.805 38.7712 129.808 38.7601C130.067 37.5507 130.244 35.081 128.933 34.6558C128.907 34.6474 128.879 34.6489 128.854 34.6591C120.254 38.1368 110.668 41.0173 98.3488 43.2021"
      stroke="#211249"
      strokeWidth="0.607787"
    />
    <Path
      d="M89.0221 60.4749C83.1387 66.8932 77.664 69.3374 73.4906 71.1608C70.5749 72.6472 64.2522 73.7135 67.081 69.1055C79.2368 53.9351 81.911 51.2973 84.7676 48.6839C86.4083 47.1829 87.138 46.2527 91.2709 45.1587"
      stroke="#211249"
      strokeWidth="0.607787"
    />
    <Path
      d="M138.131 19.1445H133.025C132.522 19.1445 132.114 19.5527 132.114 20.0562V23.8245C132.114 24.328 132.522 24.7362 133.025 24.7362H138.131C138.634 24.7362 139.043 24.328 139.043 23.8245V20.0562C139.043 19.5527 138.634 19.1445 138.131 19.1445Z"
      stroke="#211249"
      strokeWidth="0.607787"
    />
    <Path
      d="M146.761 17.686H143.358C142.854 17.686 142.446 18.0942 142.446 18.5977V23.46C142.446 23.9635 142.854 24.3717 143.358 24.3717H146.761C147.265 24.3717 147.673 23.9635 147.673 23.46V18.5977C147.673 18.0942 147.265 17.686 146.761 17.686Z"
      stroke="#211249"
      strokeWidth="0.607787"
    />
    <Path
      d="M155.392 14.6484H152.11C151.606 14.6484 151.198 15.0566 151.198 15.5601V23.4614C151.198 23.9649 151.606 24.373 152.11 24.373H155.392C155.895 24.373 156.303 23.9649 156.303 23.4614V15.5601C156.303 15.0566 155.895 14.6484 155.392 14.6484Z"
      stroke="#211249"
      strokeWidth="0.607787"
    />
    <Path
      d="M164.266 11.5479H160.862C160.191 11.5479 159.647 12.0921 159.647 12.7634V23.4605C159.647 24.1318 160.191 24.6761 160.862 24.6761H164.266C164.937 24.6761 165.481 24.1318 165.481 23.4605V12.7634C165.481 12.0921 164.937 11.5479 164.266 11.5479Z"
      fill="#211249"
    />
    <Path
      d="M173.261 17.2002H169.979C169.475 17.2002 169.067 17.6084 169.067 18.1119V23.4604C169.067 23.9639 169.475 24.3721 169.979 24.3721H173.261C173.765 24.3721 174.173 23.9639 174.173 23.4604V18.1119C174.173 17.6084 173.765 17.2002 173.261 17.2002Z"
      stroke="#211249"
      strokeWidth="0.607787"
    />
    <Path
      d="M182.377 20.2397H178.974C178.47 20.2397 178.062 20.6479 178.062 21.1514V23.461C178.062 23.9645 178.47 24.3727 178.974 24.3727H182.377C182.881 24.3727 183.289 23.9645 183.289 23.461V21.1514C183.289 20.6479 182.881 20.2397 182.377 20.2397Z"
      stroke="#211249"
      strokeWidth="0.607787"
    />
    <Path
      d="M168.52 0H156.729C156.058 0 155.514 0.544231 155.514 1.21557V7.77968C155.514 8.45102 156.058 8.99525 156.729 8.99525H168.52C169.192 8.99525 169.736 8.45102 169.736 7.77968V1.21557C169.736 0.544231 169.192 0 168.52 0Z"
      fill="#211249"
    />
    <Path
      d="M162.625 9.87749C162.528 9.98935 162.356 9.98935 162.258 9.87749L161.211 8.66846C161.074 8.51101 161.186 8.26611 161.394 8.26611H163.49C163.698 8.26611 163.809 8.51101 163.673 8.66846L162.625 9.87749Z"
      fill="#211249"
    />
    <Path
      d="M167.67 4.1333H159.89C159.621 4.1333 159.404 4.35099 159.404 4.61953C159.404 4.88807 159.621 5.10576 159.89 5.10576H167.67C167.938 5.10576 168.156 4.88807 168.156 4.61953C168.156 4.35099 167.938 4.1333 167.67 4.1333Z"
      fill="white"
    />
    <Path
      d="M157.945 4.61956C157.945 4.41815 157.782 4.25488 157.58 4.25488C157.379 4.25488 157.216 4.41815 157.216 4.61956C157.216 4.82096 157.379 4.98423 157.58 4.98423C157.782 4.98423 157.945 4.82096 157.945 4.61956Z"
      stroke="white"
      strokeWidth="0.243115"
    />
    <Path
      d="M163.05 6.44287H159.89C159.621 6.44287 159.404 6.66056 159.404 6.9291C159.404 7.19764 159.621 7.41533 159.89 7.41533H163.05C163.319 7.41533 163.537 7.19764 163.537 6.9291C163.537 6.66056 163.319 6.44287 163.05 6.44287Z"
      fill="white"
    />
    <Path
      d="M160.741 1.70215H157.58C157.312 1.70215 157.094 1.91984 157.094 2.18838C157.094 2.45692 157.312 2.67461 157.58 2.67461H160.741C161.009 2.67461 161.227 2.45692 161.227 2.18838C161.227 1.91984 161.009 1.70215 160.741 1.70215Z"
      fill="white"
    />
    <Path
      d="M158.066 6.9291C158.066 6.66056 157.849 6.44287 157.58 6.44287C157.312 6.44287 157.094 6.66056 157.094 6.9291C157.094 7.19764 157.312 7.41533 157.58 7.41533C157.849 7.41533 158.066 7.19764 158.066 6.9291Z"
      fill="white"
    />
    <Path
      d="M139.932 34.5347C140.071 34.8574 140.122 35.5706 139.326 36.0031C139.268 36.0352 139.203 36.0657 139.135 36.0944C138.139 36.5102 137.891 35.8265 137.891 35.4326V35.0314"
      stroke="#211249"
      strokeWidth="0.607787"
    />
    <Path
      d="M139.803 33.5425C140.071 33.7038 140.437 34.1133 139.932 34.535C139.895 34.5665 139.852 34.598 139.803 34.6296C139.221 35.0131 138.393 35.0634 137.891 35.0317C137.799 35.0258 137.719 35.0173 137.652 35.0076C137.381 34.9319 136.944 34.6377 137.365 34.067"
      stroke="#211249"
      strokeWidth="0.607787"
    />
    <Path
      d="M139.613 32.3608C139.884 32.4238 140.349 32.6728 140.043 33.1643C139.737 33.6558 138.194 33.9677 137.461 34.0623C137.43 34.0654 137.398 34.067 137.365 34.0669C137.076 34.0658 136.791 33.9255 136.791 33.5424C136.791 33.0011 137.493 32.8177 137.652 32.7862"
      stroke="#211249"
      strokeWidth="0.607787"
    />
    <Path
      d="M138.009 30.7542C138.28 30.8645 138.445 31.2645 137.795 31.6048C137.145 31.945 137.302 32.4083 137.461 32.5973C137.716 32.8178 138.541 32.9848 139.803 31.8884C141.066 30.7919 139.086 30.1081 137.891 29.9033"
      stroke="#211249"
      strokeWidth="0.607787"
    />
    <Path
      d="M135.213 31.8888C135.756 31.4635 136.811 30.868 136.696 31.8888C136.581 32.9097 135.852 33.354 135.5 33.4486"
      stroke="#211249"
      strokeWidth="0.607787"
    />
    <Path
      d="M135.213 35.9814C135.531 35.7085 136.072 34.8158 135.69 33.4287"
      stroke="#211249"
      strokeWidth="0.607787"
    />
    <Path d="M135.446 31.5569L134.849 28.3232" stroke="#211249" strokeWidth="0.607787" />
    <Path d="M137.584 27.7754L137.991 31.0809" stroke="#211249" strokeWidth="0.607787" />
    <Path
      d="M138.52 36.2129C138.52 37.1156 138.952 38.3034 137.991 38.5884C136.818 38.9364 136.694 37.8757 136.454 36.783L135.829 33.5049"
      stroke="#211249"
      strokeWidth="0.607787"
    />
    <Path
      d="M135.092 30.3291C134.423 30.4507 132.855 31.1314 131.931 32.8818C131.007 34.6322 130.129 35.1914 129.804 35.2522"
      stroke="#211249"
      strokeWidth="0.607787"
    />
    <Path
      d="M129.986 38.29C131.688 38.4724 135.201 38.3995 136.368 37.1353"
      stroke="#211249"
      strokeWidth="0.607787"
    />
    <Path
      d="M135.153 28.2618C138.375 28.2618 140.987 25.6495 140.987 22.427C140.987 19.2046 138.375 16.5923 135.153 16.5923C131.93 16.5923 129.318 19.2046 129.318 22.427C129.318 25.6495 131.93 28.2618 135.153 28.2618Z"
      stroke="#211249"
      strokeWidth="0.607787"
    />
    <Path
      d="M214.107 62.2719C211.776 62.7502 212.869 65.9606 211.161 66.8147C209.121 67.8345 208.418 62.0933 208.683 59.6565C208.76 58.588 210.004 58.1128 210.171 59.6565C210.35 61.2963 208.315 67.6548 205.984 65.2012L204.428 63.3998C203.995 62.8668 203.143 62.1262 202.422 63.3998C201.701 64.6734 200.552 64.2526 200.069 63.8829L198.548 62.7764"
      stroke="#211249"
      strokeWidth="0.607787"
    />
    <Path
      d="M199.638 57.8716L187.533 55.8212C187.414 55.8009 187.341 55.9499 187.432 56.0314L193.039 61.0808C193.048 61.0888 193.057 61.0955 193.069 61.0998C193.565 61.2949 195.469 60.5449 196.482 60.0913C196.551 60.0607 196.63 60.0981 196.65 60.1701C196.884 60.9877 197.166 61.7435 197.31 62.1038C197.332 62.1568 197.39 62.1861 197.429 62.1439C197.7 61.8449 197.738 60.3227 197.719 59.4491C197.717 59.3867 197.762 59.3339 197.824 59.3218C198.57 59.1763 199.577 58.5217 200.006 58.1979"
      stroke="#211249"
      strokeWidth="0.607787"
    />
    <Path
      d="M196.603 60.0067C195.312 59.4124 192.045 57.924 189.309 56.7246"
      stroke="#211249"
      strokeWidth="0.607787"
    />
    <Path d="M197.332 62.1945L194.901 60.7358" stroke="#211249" strokeWidth="0.607787" />
    <Path d="M196.846 58.7913L193.564 57.8188" stroke="#211249" strokeWidth="0.607787" />
    <Path
      d="M89.5967 45.6941C88.7256 44.6811 87.5059 42.5457 89.5967 42.1081C92.2102 41.5611 98.1057 41.6827 98.3488 43.1413"
      stroke="#211249"
      strokeWidth="0.607787"
    />
    <Path
      d="M61.6006 77.6702C62.0733 77.9257 63.4986 78.0231 65.4177 76.3679C67.3369 74.7126 67.7566 73.237 67.7266 72.7061"
      stroke="#211249"
      strokeWidth="0.607787"
    />
    <Path
      d="M59.2257 77.6298C59.1719 78.0866 59.4753 78.7871 61.1184 77.9343L61.6004 77.6701L62.4387 77.2104"
      stroke="#211249"
      strokeWidth="0.607787"
    />
    <Path
      d="M58.7974 76.2153C58.4113 76.442 57.7893 77.0275 58.39 77.5561C58.5713 77.7156 58.8709 77.72 59.2251 77.6305C60.0448 77.4232 61.1566 76.7129 61.768 76.2567"
      stroke="#211249"
      strokeWidth="0.607787"
    />
    <Path
      d="M65.9616 70.466C65.0556 70.1332 63.1839 69.484 61.94 69.9161C61.6278 70.0333 60.9203 70.1947 60.5873 69.903C60.1712 69.5384 59.3824 70.4737 60.4549 71.0995C61.5276 71.7252 62.2263 71.0618 62.0842 72.0552C61.9705 72.85 59.7696 74.1397 58.6834 74.6852C58.2932 74.8619 57.6485 75.3743 58.1919 76.0104C58.3265 76.1679 58.5403 76.2259 58.7986 76.2153C59.5839 76.183 60.7812 75.5173 61.4206 75.0861"
      stroke="#211249"
      strokeWidth="0.607787"
    />
    <Path
      d="M34.1191 26.7243C37.3227 30.0034 43.2747 31.4483 46.412 31.8428C46.6337 31.8707 46.7117 32.1591 46.5318 32.2918L38.2773 38.3802C38.2505 38.4001 38.2195 38.4143 38.1869 38.4216C32.0752 39.7856 26.3772 33.7015 24.1163 30.2451C24.0301 30.1135 24.0943 29.9387 24.2435 29.8886L33.8646 26.6621C33.9543 26.632 34.0529 26.6566 34.1191 26.7243Z"
      stroke="#211249"
      strokeWidth="0.607787"
    />
    <Path
      d="M29.3933 31.718C30.3658 31.516 32.4809 30.8871 33.1616 29.9868"
      stroke="#211249"
      strokeWidth="0.607787"
    />
    <Path
      d="M32.1283 33.9062C32.7361 33.9263 34.134 33.6266 34.8633 32.2651"
      stroke="#211249"
      strokeWidth="0.607787"
    />
    <Path
      d="M35.1057 35.3645C36.0174 35.2429 37.9745 34.55 38.5093 32.751"
      stroke="#211249"
      strokeWidth="0.607787"
    />
    <Path
      d="M13.6164 52.1296C10.4127 55.4086 4.46075 56.8536 1.32348 57.248C1.10176 57.276 1.02372 57.5643 1.20363 57.6971L9.4581 63.7855C9.48497 63.8053 9.51596 63.8196 9.54854 63.8268C15.6603 65.1908 21.3583 59.1068 23.6192 55.6504C23.7054 55.5188 23.6412 55.344 23.492 55.2939L13.8709 52.0674C13.7812 52.0372 13.6826 52.0619 13.6164 52.1296Z"
      stroke="#211249"
      strokeWidth="0.607787"
    />
    <Path
      d="M18.3429 57.1233C17.3704 56.9213 15.2553 56.2923 14.5746 55.3921"
      stroke="#211249"
      strokeWidth="0.607787"
    />
    <Path
      d="M15.6077 59.3119C14.9999 59.3321 13.602 59.0323 12.8727 57.6709"
      stroke="#211249"
      strokeWidth="0.607787"
    />
    <Path
      d="M12.6292 60.7712C11.7175 60.6496 9.76044 59.9568 9.22559 58.1577"
      stroke="#211249"
      strokeWidth="0.607787"
    />
    <Path
      d="M53.5317 74.3807C49.8945 76.2213 43.0404 76.616 42.6197 65.0466C42.199 53.4772 32.4526 53.1264 27.6321 54.3975"
      stroke="#211249"
      strokeWidth="0.61594"
    />
  </Svg>
);
